import classnames from 'classnames'
import { CuiMealInfoTooltip } from 'front-lib'
import { useBoxOrderingModel } from 'src/hooks/useBoxOrderingModel'
import { ButtonClear } from '../CartSectionHeader/components/ClearButton/ButtonClear'
import './CartSectionHeaderTitle.scss'

const CartSectionHeaderTitle = ({
  title,
  subtitle,
  showClear = undefined,
  handleClear = undefined,
  showAddonsInfo = false,
  shouldShowLoadingBar = false,
  showBOMHeader = false,
  clearCartTitle = 'Clear cart',
  isRecommendedForYou = false
}) => {
  const { isBOM, currentBox } = useBoxOrderingModel()

  return (
    <div className="cart-section-header__title">
      {(() => {
        if (isBOM && showBOMHeader && currentBox) {
          if (currentBox.isCompleted) {
            return (
              <div>
                <div className="completed-title">All the way up!</div>
                <div className="completed-subtitle">
                  You can add more or continue
                </div>
              </div>
            )
          }

          return (
            <div>
              <div className="completed-title">Fill up your box!</div>
              <div className="completed-subtitle">
                Reach at least <span>${currentBox.minPrice}</span> to place your
                order
              </div>
            </div>
          )
        }

        return (
          <>
            <div className="titles-container">
              {!!title && (
                <span
                  className={classnames('cart-section-header__title-main', {
                    recommended: isRecommendedForYou
                  })}>
                  <span>{title}</span>
                  {showAddonsInfo && (
                    <CuiMealInfoTooltip
                      tooltipText={
                        'Add-ons do not count toward the order minimum'
                      }></CuiMealInfoTooltip>
                  )}
                </span>
              )}
              {!shouldShowLoadingBar && !!subtitle && (
                <span
                  className={classnames(
                    'cart-section-header__title-secondary',
                    {
                      recommended: isRecommendedForYou
                    }
                  )}>
                  {subtitle}
                </span>
              )}
            </div>
            <div className="clear-button-container">
              {showClear && (
                <ButtonClear
                  isRecommendedForYou={isRecommendedForYou}
                  clearCartTitle={clearCartTitle}
                  handleClear={handleClear}
                />
              )}
            </div>
          </>
        )
      })()}
    </div>
  )
}

export default CartSectionHeaderTitle
